/** The overview's sort choices: `?sort` values, which are the backend's `GTSortFilter` names, and their labels. */
export const GT_SORT_LABELS = {
    status_asc: 'Needs work first',
    updated_desc: 'Newest upload',
    updated_asc: 'Oldest upload',
    file_asc: 'Name',
} as const;

export type GtSortOption = keyof typeof GT_SORT_LABELS;

export const GT_SORT_OPTIONS = Object.keys(GT_SORT_LABELS) as [
    GtSortOption,
    ...GtSortOption[],
];

/** The overview's order when `?sort` is absent: files that need work first. */
export const DEFAULT_GT_SORT: GtSortOption = 'status_asc';
